/**
 * Combine all reducers in this file and export the combined reducers.
 * If we were to do this in store.js, reducers wouldn't be hot reloadable.
 */

import { combineReducers } from 'redux';

import { LOCATION_CHANGE } from 'utils/routerRedux';
import { accountReducer, userReducer } from 'containers/App/reducer';
import profileInputReducer from 'containers/ProfileInput/reducer';
import nestedTeamListReducer from 'containers/NestedTeamList/reducer';
import goalProgressOverTimeModalReducer from 'containers/GoalProgressOverTimeModal/reducer';
import keyResultProgressOverTimeModalReducer from 'containers/KeyResultProgressOverTimeModal/reducer';

/*
 * routeReducer
 *
 * The reducer merges route location changes into our state.
 *
 */

// Initial routing state
const routeInitialState = {
  locationBeforeTransitions: null,
};

/**
 * Merge route into the global application state
 */
function routeReducer(state = routeInitialState, action) {
  switch (action.type) {
    /* istanbul ignore next */
    case LOCATION_CHANGE:
      return {
        ...state,
        locationBeforeTransitions: action.payload,
      };

    default:
      return state;
  }
}

/**
 * Creates the main reducer with the asynchronously loaded ones
 */
export default function createReducer(asyncReducers) {
  return combineReducers({
    route: routeReducer,

    profileInput: profileInputReducer,
    nestedTeamList: nestedTeamListReducer,
    goalProgressOverTimeModal: goalProgressOverTimeModalReducer,
    keyResultProgressOverTimeModal: keyResultProgressOverTimeModalReducer,

    app: combineReducers({
      account: accountReducer,
      user: userReducer,
    }),

    ...asyncReducers,
  });
}
